import React from 'react';
import GaugeChart from 'react-gauge-chart';

interface DeviationGaugeProps {
  deviation: number
  deviationLimit: number
  className?: string
  valueClassName?: string
  animate?: boolean
}

/**
 * A card that flips and alternates displayed portfolio values between MONEY (R$) and PERCENTAGE (%).
 */
const DeviationGauge: React.FC<DeviationGaugeProps> = (props: DeviationGaugeProps) => {

  const percentValue = Math.min(Math.abs(props.deviation), props.deviationLimit) / props.deviationLimit;
  const colors: string[] = [];
  const neutralColor = "#e7e5e4";
  const needleColor = "#cccccc";

  if (percentValue === 1) {
    colors.push(...[neutralColor, neutralColor, "#ef4444"])
  } else if (percentValue > 2 / 3) {
    colors.push(...[neutralColor, neutralColor, "#fb923c"])
  } else if (percentValue > 1 / 3) {
    colors.push(...[neutralColor, "#eab308", neutralColor])
  } else {
    colors.push(...["#075985", neutralColor, neutralColor])
  }

  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <div className={props.className}>
        <GaugeChart
          nrOfLevels={3}
          colors={colors}
          needleColor={needleColor}
          needleBaseColor={needleColor}
          arcWidth={0.3}
          arcPadding={0.06}
          marginInPercent={0.01}
          hideText={true}
          animate={props.animate ?? true}
          animDelay={0}
          percent={percentValue}
        />
      </div>
      <label className={props.valueClassName}>{(props.deviation * 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %</label>
    </div>
  );
}

export default DeviationGauge;